import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { DiagnosisChoice } from "./components/DiagnosisChoice";

type DiagnosisProps = {
	region: string;
}

export type Answer = {
	id : number,
	next_question_id: number;
	answer: string;
}

const Diagnosis = (props: DiagnosisProps) => {
	
	const [questionId, setQuestionId] = useState(0);
	const [question, setQuestion] = useState({choices: [] as Answer[] });
	const [answers, setAnswers] = useState([] as Answer[]);

	const regionArr:{[key: string]: string}  = {
		        '1': '首',
		        '2': '背中',
		        '3': '肩',
		        '4': '腰',
		        '5': '肘',
		        '6': '股関節',
		        '7': '手首',
		        '8': '膝',
		        '9': '手・指',
		        '10': '足首',
		        '11': '足・足の指',
		        '12': '腕',
		        '13': '脚',
		        '14': 'その他',
		};
	

	useEffect(() => {

		if (questionId === 0) {
			const answer: Answer = {
				id: 1,
				next_question_id: 0,
				answer: '痛みの場所：' + regionArr[props.region]
			};
			answers.push(answer);
		}
		
		fetch(`https://orthopedics-diagnosis.com/diagnosis/api/diagnosis/${props.region}/${questionId}`)
			.then(res => res.json())
			.then(
				(result) => {
					setQuestion(result);
					console.log(result);
				},
				(error) => {
					console.log(error);
				}
			);

	}, [questionId])

	const onAnswerSelected = (answer: Answer) => {
		
		if (answer.next_question_id) {
			setQuestionId(answer.next_question_id);
			setAnswers([...answers, answer]);
		} else {
			setQuestionId(-1);
			window.location.href = `../result/${answer.id}`;
		}
		
	};

	return (
		<div className="row">
			<div className="col-md-6">
				<div className="card mb-4">
					<div className="card-body mb-4">
						<h3><FontAwesomeIcon icon={faQuestionCircle} /> 質問に順に回答してください <small>（ {answers.length + 1} / 5 項目）</small></h3>
						{question.choices.map((choice, index) => {
							return <DiagnosisChoice key={index} onAnswerSelected={onAnswerSelected} choice={choice}  />
						})}
					</div>
				</div>
			</div>
			<div className="offset-md-1 col-md-5">

				<h3>ここまでの回答</h3>
				{answers.map((answer, index) => {
					return <div key={index}>
					<p><FontAwesomeIcon icon={faQuestionCircle} /> 質問{index + 1}</p>
					<p>{answer.answer}</p>
					</div>
				})}
			</div>
		</div>
	);
};

export { Diagnosis };
